import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=b3b3fe52&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3b3fe52')) {
      api.createRecord('b3b3fe52', component.options)
    } else {
      api.reload('b3b3fe52', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=b3b3fe52&", function () {
      api.rerender('b3b3fe52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NuHomeCloneProductCarousel/Carousel.vue"
export default component.exports